<template>
  <div v-if="page.totalCount>0" class="flex-row-reverse p-20">
    <el-pagination
      size="small"
      :total="page.totalCount"
      :page-size="page.perPage"
      :current-page="page.currentPage"
      :page-sizes="[20, 50, 100]"
      layout="total, sizes, prev, pager, next, jumper"
      @current-change="handleChange"
      @size-change="handleChangePageSize"
    />
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["handleCurrentChange"],
  methods: {
    handleChange(val) {
      this.$emit("handleCurrentChange", { page: val, limit: this.page.perPage });
    },
    handleChangePageSize(val) {
      this.$emit("handleCurrentChange", { page: this.page.currentPage, limit: val });
    }
  }
};
</script>

<style lang="less" scoped>

</style>
